import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contentContainerGrid: {
    width: "auto",
    margin: "auto",
    marginTop: -6,
    "& > div:last-of-type *:last-child": {
      marginBottom: 13,
    },
    "& > div:first-of-type": {
      margin: 0,
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      maxWidth: "90rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      maxWidth: "53.75rem",
    },
  },

  policy: {
    fontFamily: "var(--font-family-3)",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: 1.6,
    textAlign: "justify",
    color: "#a6b5d9",
    "p,span,strong": {
      color: "#a6b5d9",
      margin: 0,
      padding: 0,
    },
    "& h2": {
      fontFamily: "var(--font-family-1)",
      fontSize: "16px",
      fontWeight: 500,
      color: "#677aa7",
      marginBottom: "32px",
    },

    "& h4": {
      fontWeight: 700,
      color: "#c0cce7ff",
      margin: "22px 0 10px",
    },

    "& a": {
      textDecoration: "underline",
      cursor: "pointer",
      marginBottom: 0,
      marginTop: 30,
      lineHeight: 1.6,
      color: "#954f72",
    },

    "& ul": {
      paddingLeft: "16px;",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },

    "& li::marker": {
      color: "#a6b5d9",
    },
  },
}));

export default useStyles;
